import { RESET_ALL_ACCOUNT_STATE_DEPEN } from "../../actions/commonActions";
import { FETCH_PITCH_WO_CARD_FAILURE, FETCH_PITCH_WO_CARD_REQUEST, FETCH_PITCH_WO_CARD_SUCCESS } from "../../actions/opportunities/pitchCardWOActions";

  const initialState = {
    pitchWoLoading: false,
    pitchWoData: [],
    pitchWoError: null,
  };
  
  const pitchWoReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_PITCH_WO_CARD_REQUEST:
        return { ...state, pitchWoLoading: true , payload: action.payload};
      case FETCH_PITCH_WO_CARD_SUCCESS:
        return { ...state, pitchWoLoading: false, pitchWoData: action.payload };
      case FETCH_PITCH_WO_CARD_FAILURE:
        return { ...state, pitchWoLoading: false, pitchWoError: action.payload }; 
      case RESET_ALL_ACCOUNT_STATE_DEPEN:
              return initialState           
      default:
        return state;
    }
  };
  
  export default pitchWoReducer;
  